/* eslint-disable react-hooks/exhaustive-deps */
import {TextField} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {i18n2} from 'features/i18n/i18n';
import {Field} from 'formik';
import {matchYoutubeUrl} from 'helpers/functions';
import React, {useEffect, useState} from 'react';
import AddPDF from './DropZone';
import {Alert} from '@material-ui/lab';

const MediaSelect = ({setFieldValue, isEditing, pdfName, urlMedia}) => {
  const [isYoutube, setIsYoutube] = useState('sharepoint');
  const [name, setName] = useState(pdfName);
  const [error, setError] = useState();
  useEffect(() => {
    if (isEditing) {
      if (pdfName.includes('microsoftstream')) {
        setIsYoutube('stream');
      } else if (pdfName.includes('drive.google.com')) {
        setIsYoutube('google');
      } else matchYoutubeUrl(pdfName) === false && setIsYoutube('media');
    }
  }, [isEditing]);

  useEffect(() => {
    setFieldValue('name', name);
  }, [name]);

  return (
    <>
      <Grid item xs={12}>
        <Select
          value={isYoutube || ''}
          onChange={(x) => {
            setIsYoutube(x.target.value);
          }}
          fullWidth
          variant="outlined"
          label={i18n2._('Tipo')}
          name="tipo"
          disabled={isEditing}
          required>
          <MenuItem value={'sharepoint'}>Sharepoint</MenuItem>
          <MenuItem value={'google'}>Google Drive</MenuItem>
          <MenuItem value={'stream'}>Microsoft Stream (Clasico)</MenuItem>
          <MenuItem value={'media'}>{i18n2._('Subir nuevo')}</MenuItem>
        </Select>
        {isYoutube === 'sharepoint' && (
          <Alert
            style={{marginBottom: '10px', marginTop: '10px'}}
            severity="warning">
            En el campo "Link" se debe colocar el "código para insertar".
            (iframe)
          </Alert>
        )}
        {isYoutube === 'stream' && (
          <Alert
            style={{marginBottom: '10px', marginTop: '10px'}}
            severity="warning">
            Para subir video desde Microsoft Stream, asegúrate de utilizar la
            versión clásica del sitio (URL que comienza con
            https://web.microsoftstream.com/).
          </Alert>
        )}
        {isYoutube === 'google' && (
          <Alert
            style={{marginBottom: '10px', marginTop: '10px'}}
            severity="warning">
            En el campo "Link" se debe colocar el enlace o código para insertar
            (iframe) de Google Drive.
          </Alert>
        )}
      </Grid>
      <Grid item xs={12}>
        {isYoutube === 'media' ? (
          <AddPDF
            setFieldValue={setFieldValue}
            isEditing={isEditing}
            pdfName={pdfName}
            extension="multimedia"
            urlMedia={urlMedia}
          />
        ) : (
          <>
            <Field
              name={'name'}
              required
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              component={TextField}
              label={i18n2._('Link')}
              autoFocus
              fullWidth
              variant="outlined"
              validate={(value) => {
                let error;
                if (value === null) {
                  error = i18n2._('Please provide a media');
                }
                if (
                  // matchYoutubeUrl(value) === false &&
                  value.includes('microsoftstream') === false &&
                  value.includes('sharepoint') === false &&
                  value.includes('drive.google.com') === false
                ) {
                  error = i18n2._('Please provide a URL');
                }
                setError(error);
                return error;
              }}
            />
            <p style={{color: 'red'}}>{error}</p>
          </>
        )}
      </Grid>
    </>
  );
};

export default MediaSelect;
